import { BREAKPOINTS } from 'shared/scss'
import { useMediaQuery } from 'react-responsive'

function useBreakpoint(breakpoint) {
  return useMediaQuery({ query: `(min-width: ${BREAKPOINTS[breakpoint]}px)` })
}

export default useBreakpoint
